<template>
  <section class="cta">
    <router-link
      :to="{ name: 'Contact' }"
      tag="h3"
      class="cta__title">
      Contact
    </router-link>
    <h3
      v-hover-scale-mouse
      data-apollo-hover
      ref="subtitle"
      class="cta__subtitle"
      @click="goAt"
      @mouseenter="mEnter"
      @mouseleave="mLeave"
    >
      do you fancy a cappuccino?
    </h3>
  </section>
</template>

<script>
import { SplitText } from '@/scripts/SplitText';
import letterSpacingAnimation from '@/mixins/letterSpacingAnimation';

export default {
  name: 'ContactCTA',
  mixins: [letterSpacingAnimation],
  mounted() {
    return new SplitText(this.$refs.subtitle, { charsClass: 'stagger-element' });
  },
  methods: {
    goAt() {
      this.$router.push({ name: 'Contact' });
    },
  },
};
</script>

<style scoped lang="scss">
.cta {
  display: flex;
  justify-content: center;
  align-items: center;

  overflow: hidden;

  font-family: $font-family-h;
  text-transform: uppercase;

  @include mq(ipadP) {
    height: 18vw;
  }

  &__title {
    width: 100%;
    opacity: 0.1;
    line-height: 1;
    font-size: 20vw;

    @include mq(ipadP) {
      font-size: 18vw;
      transform: none;
    }

    @include mq(ipadL) {
      font-size: 9.6vw;
    }
  }
  &__subtitle {
    position: absolute;
    transform: translateY(25%);

    cursor: pointer;
  }
}
</style>
